"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environments = void 0;
const environments = {
  PROD: "production",
  QA: "qa"
};
exports.environments = environments;